import { render, staticRenderFns } from "./AccreditedReporting.vue?vue&type=template&id=147f366c"
import script from "./AccreditedReporting.vue?vue&type=script&lang=js"
export * from "./AccreditedReporting.vue?vue&type=script&lang=js"
import style0 from "./AccreditedReporting.vue?vue&type=style&index=0&id=147f366c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports